import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/clients',
        name: 'Pregled accountov',
        component: () => import('@/views/Clients.vue'),
      },
      {
        path: '/client/:id',
        name: 'Account',
        component: () => import('@/views/Client.vue'),
      },
      {
        path: '/brainstormings',
        name: 'Brainstormingi',
        component: () => import('@/views/Brainstormings.vue'),
      },
      {
        path: '/brainstorming/:id',
        name: 'Brainstorming',
        component: () => import('@/views/Brainstorming.vue'),
      },
      {
        path: '/scenes',
        name: 'Scenariji',
        component: () => import('@/views/Scenes.vue'),
      },
      {
        path: '/posts',
        name: 'Plani objav',
        component: () => import('@/views/Posts.vue'),
      },
      {
        path: '/influencers',
        name: 'Vplivneži',
        component: () => import('@/views/Influencers.vue'),
      },
      {
        path: '/brands',
        name: 'Znamke',
        component: () => import('@/views/Brands.vue'),
      }
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
  {
    path: '/reports',
    name: 'Reports',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '/reports/accounts/:type',
        name: 'AccountsReport',
        component: () => import('@/reports/Accounts.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
